import React, { useState, useEffect } from "react";
import {  Drawer } from "antd";
import { userData } from "../../../utils/service";
import Logo from "../../../assets/images/auths/logo.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import HamburgIcon from "../../../assets/images/hamburg-icon.svg";
import { useMyContext } from "../../../helpers/Context/MyContext";
import { setExCluded, setPromoApplied } from "../../../utils/localStorage";
import {
  setNavItem,
  getNavItem,
  removeToken,
  removeNavItem,
  removeURL,
  removeExcluded,
  removePromoApplied,
} from "../../../utils/localStorage";
import Cookies from "js-cookie";
import "./InternalNavbar.scss";
import { getAccountId,getToken } from "../../../utils/localStorage";

const navData = [
  {
    key: 0,
    name: "Home",
    link: "/",
  },
  {
    key: 1,
    name: "Games",
    link: "/game",
  },
  {
    key: 2,
    name: "Insights",
    link: "/insights",
  },
  {
    key: 3,
    name: "Dashboard",
    link: "/dashboard",
  },
  {
    key: 4,
    name: "Rules",
    link: "/rules",
  },
  {
    key: 5,
    name: "Activity",
    link: "/activity",
  },
];

const InternalNavbar = () => {
  const [open, setOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(0);
  const [profileData, setProfileData] = useState();
  const [placement, setPlacement] = useState("top");
  const [isNavigating, setIsNavigating] = useState(false);
  const { contextData, setContextData } = useMyContext();
  const navigate = useNavigate();
  const location = useLocation();
  const navItem = getNavItem();
  const token = getToken();
  const playerId = getAccountId();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    removeToken();
    Cookies.remove("user_token", {
      domain:
        process.env.NODE_ENV !== "development"
          ? ".championschoice.co.uk"
          : "localhost",
    });
    removeNavItem();
    removeURL();
    removeExcluded();
    removePromoApplied();
    // navigate("/login");
    setContextData("");
  };

  const externalUrl = process.env.REACT_APP_BetArabia_URL?.trim() ||
    "https://www.betarabia.com/en/casino/provider/ChampionsChoice";
  const envValue = String(process.env.REACT_APP_CUSTOM_ENV || "").trim().toLowerCase();
  const isProduction = envValue === "production" || process.env.NODE_ENV === "production";

  const handleLogoClick = () => {
    const targetUrl = isProduction ? externalUrl : "/";
    console.log("logo click", { envValue, isProduction, targetUrl });
    if (isProduction) {
      // Navigate parent window to avoid iframe loop
      if (window.top !== window) {
        window.top.location.href = targetUrl;
      } else {
        window.location.href = targetUrl;
      }
      return;
    }
    navigate(targetUrl);
    setNavItem(0);
  };

  const handleMenuClick = (item) => {
    setNavItem(null);
    if (item.key == 0) {
      navigate("/personalinformation");
    } else if (item.key == 1) {
      navigate("/payment");
    } else if (item.key == 2) {
      navigate("/notifications");
    } else if (item.key == 3) {
      navigate("/activity");
    } else if (item.key == 4) {
      navigate("/referafriend");
    } else if (item.key == 5) {
      // setHideDepositButton(5);
      navigate("/safergambling");
    } else if (item.key == 6) {
      handleLogout();
    }
    setOpen(false);
  };

  const getUserData = async () => {
    removeExcluded();
    removePromoApplied();
    const payload = {
      token_id: token,
      player_id: playerId
    }
    const res = await userData(payload,token,playerId);
    setProfileData(res);
    setContextData({
      ...contextData,
      onGoingGames: res?.games_count,
      balance: res?.balance,
      userData: res,
      isExcluded: res?.is_excluded,
      promoCodeApplied: res?.promo_code_applied,
    });
    if (res?.is_excluded) {
      setExCluded(true);
    }
    if (res?.promo_code_applied) {
      setPromoApplied(res?.promo_code_applied);
    }
  };

  function formatNumber(num) {
    if (typeof num !== "number" || isNaN(num)) {
      return ""; // Return an empty string or handle it as you prefer.
    }

    let formattedNum;
    if (num >= 1000) {
      formattedNum = Math.floor((num / 1000) * 100) / 100;
      return formattedNum.toFixed(2) + "k";
    } else {
      return num.toFixed(2);
    }
  }

  useEffect(() => {
    if (!navItem) {
      setNavItem(0);
    }
  }, []);

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <div className="internal-main">
      <nav className="internal-navigation-bar">
        <div className="logo cursor-pointer" onClick={handleLogoClick}>
          <img src={Logo} alt="Logo" />
        </div>
        <div className="internalnav-main">
          <ul className="nav-links">
            {navData?.map((item, index) => {
              return (
                <li key={item.key} className="position-relative">
                  <Link
                    to={item.link}
                    className="nav-links-list"
                    onClick={() => {
                      setActiveItem(item.key);
                      setNavItem(item.key);
                    }}
                  >
                    {item.name}
                  </Link>
                  {item.key === 3 && contextData?.onGoingGames > 0 && (
                    <div className="dasboard-notification font-cairo-bold">
                      {contextData?.onGoingGames}
                    </div>
                  )}
                  {navItem == item.key && (
                    <div className="nav-links-below-line"></div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        <div
          className="internal-navbar-right"
          style={{
            justifyContent:
              location?.pathname === "/safergambling" ||
              location?.pathname === "/payment"
                ? "end"
                : "space-between",
          }}
        >
          <div className="profile-details">
            <div
              className="internal-main-notifications"
              onClick={() => {
                navigate("/notifications");
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                  stroke="#fff017"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.73 21a2 2 0 0 1-3.46 0"
                  stroke="#fff017"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {contextData?.userData?.notification_count > 0 && (
                <div className="internal-main-notifications-count font-cairo-bold">
                  {contextData?.userData?.notification_count}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="external-hamburg">
          <div onClick={showDrawer}>
            <img src={HamburgIcon} alt="Hamburg Icon" />
          </div>
          <Drawer
            placement={placement}
            width={500}
            // Upper bound only, not a real target size: antd's own default
            // for an unset height is 378px, which is shorter than this menu
            // needs on any screen tall enough to show it without scrolling.
            // On screens shorter than this (e.g. inside a constrained
            // iFrame), `.internal-mobile-drawer`'s `max-height` in
            // InternalNavbar.scss clamps the actual rendered height down to
            // fit — that CSS rule is what makes this responsive, not this
            // number. Don't remove the SCSS max-height rule assuming this
            // prop alone is safe.
            height={505}
            onClose={onClose}
            className="internal-mobile-drawer container-border"
            open={open}
            extra={
              <div
                className="mobile-navbar-right"
                style={{
                  justifyContent:
                    (location?.pathname === "/safergambling" ||
                      location?.pathname === "/payment") &&
                    "flex-end",
                }}
              >
                <div className="profile-details">
                  <div
                    className="internal-profile-icon"
                    onClick={() => {
                      navigate("/notifications");
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                        stroke="#fff017"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.73 21a2 2 0 0 1-3.46 0"
                        stroke="#fff017"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {contextData?.userData?.notification_count > 0 && (
                      <div className="internal-main-notifications-count font-cairo-bold">
                        {contextData?.userData?.notification_count}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
          >
            <div className="externalnav-mobile">
              <ul className="mobile-nav-links">
                {navData?.map((item, index) => {
                  return (
                    <li
                      key={item.key}
                      className="mobile-links-list position-relative"
                    >
                      <Link
                        to={item.link}
                        className={`link-style externalnav-links-list-item ${
                          index == activeItem ? "primary-color" : null
                        }`}
                        onClick={() => {
                          setActiveItem(item.key);
                          setOpen(false);
                        }}
                      >
                        {item.name}
                      </Link>
                      {item.key === 3 && contextData?.onGoingGames > 0 && (
                        <div className="dasboard-notification font-cairo-bold">
                          {contextData?.onGoingGames}
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </Drawer>
        </div>
      </nav>
    </div>
  );
};

export default React.memo(InternalNavbar);
